"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var YelpBusinessDetailsDataSource =
/*#__PURE__*/
function () {
  function YelpBusinessDetailsDataSource() {
    (0, _classCallCheck2["default"])(this, YelpBusinessDetailsDataSource);
  }

  (0, _createClass2["default"])(YelpBusinessDetailsDataSource, null, [{
    key: "getName",
    value: function getName() {
      return 'Yelp Business Details';
    }
  }, {
    key: "getItemId",
    value: function getItemId(item) {
      return item.id;
    }
  }, {
    key: "mapResult",
    value: function mapResult(result) {
      var dataToMap = result && 'photos' in result && result.photos;
      var mappedResult = dataToMap.map(function (item, index) {
        // TODO map photos
        return {
          title: 'yelp',
          id: index,
          media: {
            full_picture: item,
            value: item,
            width: 1000,
            height: 666
          }
        };
      });
      return mappedResult;
    }
  }, {
    key: "getDataPromise",
    value: function getDataPromise(value, requestBody) {
      var item = [{
        id: 'accountId',
        value: value
      }];
      requestBody.item = item;
      return requestBody;
    }
  }]);
  return YelpBusinessDetailsDataSource;
}();

YelpBusinessDetailsDataSource.getRequestName = function () {
  return 'YelpBusinessDetailsApi';
};

var _default = YelpBusinessDetailsDataSource;
exports["default"] = _default;